import { FALLBACK_CLIP_TITLE } from '../constants'
import { CreationToolSourceFile } from '../types'
import CreationToolFileType from '../types/file-type'
import CreationToolUploadField from '../types/upload-field'

const getDefaultSourceTitle = ({ source, type, title: sourceTitle }: CreationToolSourceFile): string => {
    const maxLength = CreationToolUploadField.maxCharacterCount(CreationToolUploadField.VideoTitle)
    let title = sourceTitle || (typeof source === 'string' ? source : source.name)

    if (type !== CreationToolFileType.VIDEO && type !== CreationToolFileType.VIDEO_EMBED) {
        return title
    }

    if (!sourceTitle && typeof source === 'string') {
        title = FALLBACK_CLIP_TITLE
    }

    return title && maxLength ? title.substring(0, maxLength) : title
}

export default getDefaultSourceTitle
